import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";


function DocumentsAccessData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)

    return (<>
        <NoticeYesNoInput
            id={gId("ezamowieniaDemand")}
            formikProps={formikProps}
            required
            disabled
        />

        <NoticeTextInput
            id={gId("www")}
            formikProps={formikProps}
            required
        />

        <NoticeYesNoInput
            id={gId("restrictedAccess")}
            formikProps={formikProps}
            required
        />

        <Collapse in={gVal("restrictedAccess") === true}>
            <NoticeTextInput
                id={gId("restrictedAccessInfo")}
                formikProps={formikProps}
                required
            />
        </Collapse>


        <NoticeYesNoInput
            id={gId("electronicOffersOnly")}
            formikProps={formikProps}
            required
        />

        <NoticeTextInput
            id={gId("electronicOffersInfo")}
            formikProps={formikProps}
            required={!!gVal("electronicOffersOnly")}
            multiline
        />

        <NoticeTextInput
            id={gId("electronicOffersRequirements")}
            formikProps={formikProps}
            required={!!gVal("electronicOffersOnly")}
            multiline
        />

        <NoticeTextInput
            id={gId("toolsWww")}
            formikProps={formikProps}
        />

        <NoticeYesNoInput
            id={gId("toolsNotWidelyAvailable")}
            formikProps={formikProps}
            required
        />

        <Collapse in={gVal("toolsNotWidelyAvailable") === true}>
            <NoticeTextInput
                id={gId("notWidelyAvailableToolsInfo")}
                formikProps={formikProps}
                required
                multiline
            />
        </Collapse>

        <NoticeGlossaryInput
            id={gId("offerCatalog")}
            formikProps={formikProps}
            items={getDict("ENUM.005")}
            required
        />

        <Collapse in={gVal("electronicOffersOnly") === false}>
            <NoticeGlossaryInput
                id={gId("notElectronicOffersReason")}
                formikProps={formikProps}
                items={getDict("ENUM.006")}
                multiple
                required
            />
            <NoticeTextInput
                id={gId("notElectronicOffersMethod")}
                formikProps={formikProps}
                required
                multiline
            />
        </Collapse>

        <NoticeGlossaryInput
            id={gId("offerLang")}
            formikProps={formikProps}
            items={getDict("SL.MO.026")}
            multiple
            required
        />

        <NoticeTextInput
            id={gId("rodoInfo")}
            formikProps={formikProps}
            multiline
        />

        <NoticeTextInput
            id={gId("rodoLimitations")}
            formikProps={formikProps}
            multiline
        />
        <Collapse in={gVal("form.basicData.refersTo", false) === "FrameworkAgreement"}>
            <NoticeYesNoInput
                id={gId("offerCatalogUsage")}
                formikProps={formikProps}
                required
            />
        </Collapse>
    </>)
}

DocumentsAccessData.propTypes = {};

export default DocumentsAccessData;
